import React from "react";

const ORANGE = "#F27E33";
const NAVY = "#1D2946";

export default function ContactHero() {
  return (
    <section
      className="relative overflow-hidden bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: "url('/assets/images/fondo3.webp')",
      }}
    >
      {/* Overlay radial para darle contraste */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 50% at 50% 0%, rgba(11,22,32,.65) 0%, rgba(11,22,32,.85) 100%)",
        }}
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-16 relative z-10">
        <h1
          className="font-orbitron font-bold text-white text-4xl md:text-6xl text-center"
          style={{ letterSpacing: "0.02em" }}
        >
          Solicita Cotización
        </h1>

        <div className="flex justify-center mt-5 mb-6">
          <span
            className="h-1 rounded-full"
            style={{
              width: "160px",
              background: `linear-gradient(90deg, ${ORANGE}, ${NAVY})`,
              boxShadow: `0 0 18px ${ORANGE}33`,
            }}
          />
        </div>

        <p className="font-body text-white/90 text-lg md:text-xl text-center max-w-3xl mx-auto leading-relaxed">
          Cuéntanos sobre tu proyecto y uno de nuestros ingenieros te contactará
          para darte una propuesta a la medida con tiempos y alcance claros.
        </p>
      </div>
    </section>
  );
}
